/** User-facing action labels for every error-recovery surface in the fleet, so a copy change to the retry verb hits
 *  one place. The scope is NOT `components/error/**`, which is where the readers began and what this docstring used
 *  to claim: the boundary consts, the profile SPA, the wishlists MFE, the ledger checkout modal and a host app's
 *  route-level error page all read it, and a home whose docstring under-states its reach is a home the next author
 *  respells around. */

export const ERROR_ACTION_LABELS = {
	/** Primary retry button label used by createErrorPage (including the host `property/[propertyId]` route's error
	 *  page), PropertyFeedError, GlobalErrorPage, `MfeMountFallback`, `RootErrorBoundary`, the top-up checkout's
	 *  payment-failed `ErrorState`, the wishlists MFE's two `EmptyState` error actions and the mission board's pane
	 *  boundary. The wishlists pair adopted this leaf on 2026-08-22 so every surface says the verb ONE way; that stands.
	 *  SENTENCE CASE since 2026-09-15 (iss-8eb9d957): the copy leaves around it and the mission board's own copy are
	 *  sentence case, and this was the one two-word label in Title Case, so the board's read-failure alert said
	 *  "Try Again" beside words that never capitalised a second one. The sibling suite pins the shape. */
	tryAgain: 'Try again',
	/** The retry's word WHILE IT RUNS: the failure it answers stays drawn until the read lands (`readFailed`), so the
	 *  pressed control says it is working instead of vanishing (critics, 2026-09-18). */
	tryingAgain: 'Trying again\u{2026}',
} as const;
